import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BookImageType, BookStatus } from 'src/app/data/book';
import { GlobalVariables } from 'src/app/data/global-variables';
import { BookService } from 'src/app/services/book.service';
import { ImagesCacheService } from 'src/app/services/images-cache.service';
import { BookPdfFlipbookLandscapeComponent } from './book-pdf-flipbook-landscape/book-pdf-flipbook-landscape.component';
import { BookPdfFlipbookVerticalComponent } from './book-pdf-flipbook-vertical/book-pdf-flipbook-vertical.component';
import { ConfigService } from 'src/app/services/config.service';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-book-pdf-flipbook',
  templateUrl: './book-pdf-flipbook.component.html',
  styleUrls: ['./book-pdf-flipbook.component.css'],
})
export class BookPdfFlipbookComponent implements OnInit {
  //#region Attributes
  zoom: number = 1

  // Access
  token!: string;
  accessToken!: string;
  externalToken!: string;
  // accessGranted = (environment.demo) ? true : false;
  bookStatus!: BookStatus;
  BookStatus = BookStatus;
  BookImageType = BookImageType;



  // Windows
  @ViewChild(BookPdfFlipbookLandscapeComponent) bookPdfFlipbookDesktopComponent!: BookPdfFlipbookLandscapeComponent;
  @ViewChild(BookPdfFlipbookVerticalComponent) bookPdfFlipbookMobileComponent!: BookPdfFlipbookVerticalComponent;
 
  // numOfOpenViewers: number = 0
  showGrid: boolean = false
  showPreview: boolean = false

  Math = Math;
  shownVisorTip = false;
  showWindowingTool: boolean = true

  canRenewBook: boolean = false;

  //#endregion

  //#region Getters
  get isPageVertical() {
    return window.innerHeight > window.innerWidth;
  }
  //#endregion

  //#region Initialization
  constructor(
    private route: ActivatedRoute,
    public globalVariables: GlobalVariables,
    public bookService: BookService,
    public imagesService: ImagesCacheService,
    private changeDetectorRef: ChangeDetectorRef,
    private configService: ConfigService,
    private alertService: AlertService
  ) {
    registerLocaleData(localeEs, 'es');

    // Pasadas dos horas refrescamos la página
    setTimeout(() => {
      window.location.reload();
    }, 7200000);
    this.route.queryParams.subscribe(params => {
      this.token = params['tkn'];
      this.accessToken = params['acctk'];
      if (this.token != null) {
        this.bookService.checkBookStatus(this.token).subscribe(status => {
          this.bookStatus = BookStatus.sanitize(status);
        })
      }
      this.externalToken = params['extkn'];
      if (this.externalToken != null) {
        this.bookService.checkBookStatusByExternalToken(this.externalToken).subscribe(status => {
          this.bookStatus = BookStatus.sanitize(status);
        });
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.changeDetectorRef.detectChanges()

    if (this.isPageVertical) {
      // if (this.bookPdfFlipbookMobileComponent.isFlipbookLoaded) {
      //   this.bookPdfFlipbookMobileComponent.resizeBookVertical()
      // } else {
      //   this.loadBook()
      // }

    } else {
      if (this.bookPdfFlipbookDesktopComponent.isFlipbookLoaded) {
        if (!this.bookPdfFlipbookDesktopComponent.flipbookLoading) {
          this.bookPdfFlipbookDesktopComponent.resizeBook()
        }
      } else
        this.loadBook()
    }
  }

  ngOnInit(): void {
    this.loadBook();
  }

  get isPageSmall() {
    return this.globalVariables.isPageSmall;
  }

  loadBook() {
    this.changeDetectorRef.detectChanges();
    if (this.bookStatus == null) {
      setTimeout(() => {
        this.loadBook();
      }, 100);
      return;
    }
    //console.log('this.token', this.token);
    
    // Si ha expirado, comprobamos si se puede renovar el Book
    if (this.bookStatus == BookStatus.EXPIRED) {
      this.configService.systemConfig.then(c => {
        this.canRenewBook = c.canRenewExpiredBook;
        if (this.canRenewBook == true) {
          this.bookService.askForBook(this.token).then(() => {
            console.log('done!');
          }).catch(e => {
            console.error(e)
            setTimeout(() => {
              this.alertService.alert('Ha ocurrido un error tratando de recuperar el estudio. Contacte con su centro para poder visualizarlo');
            })
          })
          setInterval(() => {
            this.bookService.checkBookStatus(this.token).subscribe(status => {
              if (BookStatus.sanitize(status) == BookStatus.READY) {
                window.location.reload();
              }
            })
          }, 30000);
        }
      })
    } else {
      if (this.bookPdfFlipbookMobileComponent != null) {
        this.bookPdfFlipbookMobileComponent.loadBook();
        //this.bookPdfFlipbookMobileComponent.refreshGestures();
      }
      if (this.bookPdfFlipbookDesktopComponent != null) {
        this.bookPdfFlipbookDesktopComponent.loadBook();
        //this.bookPdfFlipbookDesktopComponent.refreshGestures();
      }
    }

  }
  //#endregion

}

